import {
  messageId,
  PropertyMeta,
  ValueObjectMetaString,
} from "@pscsrvlab/psc-react-components";
import { z } from "zod";
const minimalSchema = z.string().max(100);
const savedMinimalSchema = z.string().max(100);
const schema = z.string().min(1).max(100);
const savedSchema = z.string().min(1).max(100);
const jsonSchema = z.string();
/**
 * 細胞カテゴリ名（英）(値オブジェクト)のメタデータ。
 *
 *  */
export const cellCategoryNameEnMeta = new ValueObjectMetaString(
  "CellCategoryNameEn",
  "\u7D30\u80DE\u30AB\u30C6\u30B4\u30EA\u540D\uFF08\u82F1\uFF09",
  messageId("lbl.\u7D30\u80DE\u30AB\u30C6\u30B4\u30EA\u540D\uFF08\u82F1\uFF09"),
  minimalSchema,
  schema,
  jsonSchema,
  undefined,
  undefined
);
